


import axios, { AxiosResponse } from 'axios';
import {Response} from '../../interface/IResponse'
import {AdminRegistryTableResponse, RequestCreateAdmin, RequestUpdateAdmin, ResponseGetAdmin } from '../../interface/IAdminRegistry';



async function getAdminRegistryListFunction() : Promise<AxiosResponse<AdminRegistryTableResponse>>{

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Users";

        var response : AxiosResponse<AdminRegistryTableResponse> = await axios.get(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });


        return response;

    }
    catch(error){

        console.log('getAdminRegistryListFunction error:: ', error);

        throw error;
    }
}


async function createAdminRegistryFunction(payload: RequestCreateAdmin) : Promise<AxiosResponse<Response>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Users";

        var response : AxiosResponse<Response> = await axios.post(apiUrl, payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        return response;
    }
    catch(error){
         if(axios.isAxiosError(error)){

                throw error.response?.data.message;

            }
            else{
                throw error;
            }
    }
}


async function updateAdminRegistryFunction(username?: string, payload?: RequestUpdateAdmin): Promise<AxiosResponse<Response>>{

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Users/" + username;

        var response : AxiosResponse<Response> = await axios.put(apiUrl, payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        return response;
    }
    catch(error){
        
        if(axios.isAxiosError(error)){

            throw error.response?.data.message;

        }
        else{
            throw error;
        }
    }

}

async function getAdminFunction(username?: string): Promise<AxiosResponse<ResponseGetAdmin>> {
    try
    {

        var apiUrl = process.env.REACT_APP_API_URL + "/Users/" + username;

        var response : AxiosResponse<Response> = await axios.get(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        return response;
    }
    catch(error){
        
        console.log('getAdminFunction error:: ', error);

        if(axios.isAxiosError(error)){

            throw error.response?.data.message;

        }
        else{
            throw error;
        }
    }
}


async function deleteAdminFunction(username?: string): Promise<AxiosResponse<Response>>{

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Users/" + username;

        var response : AxiosResponse<Response> = await axios.delete(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        return response;
    }
    catch(error){
        
        if(axios.isAxiosError(error)){

            throw error.response?.data.message;

        }
        else{
            throw error;
        }
    }
}


const adminRegistryService = {
    getAdminRegistryList : getAdminRegistryListFunction,
    createAdminRegistry: createAdminRegistryFunction,
    updateAdminRegistry: updateAdminRegistryFunction,
    getAdmin: getAdminFunction,
    deleteAdmin: deleteAdminFunction
}


export default adminRegistryService;